<template>
  <div class="profile-container">
    <!-- 页面标题区域 -->
    <div class="page-title-section">
      <div class="title-content">
        <h1 class="page-title">
          <i class="el-icon-user"></i>
          个人资料
        </h1>
        <p class="page-subtitle">修改个人密码和基本信息设置</p>
      </div>
    </div>

    <!-- 表单卡片 -->
    <div class="form-card">
      <div class="form-header">
        <h3 class="form-title">
          <i class="el-icon-edit"></i>
          密码设置
        </h3>
      </div>
      
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="formData"
        label-position="left"
        label-width="120px"
        class="profile-form"
      >
        <el-form-item label="管理员名称">
          <el-input 
            v-model="formData.user_email" 
            :disabled="true"
            prefix-icon="el-icon-user" 
          />
        </el-form-item>
        
        <el-form-item label="新密码" prop="new_password">
          <el-input 
            v-model="formData.new_password" 
            placeholder="输入新密码" 
            show-password 
            prefix-icon="el-icon-lock"
          />
        </el-form-item>
        
        <el-form-item label="确认新密码" prop="renew_password">
          <el-input 
            v-model="formData.renew_password" 
            placeholder="再次输入新密码" 
            show-password 
            prefix-icon="el-icon-lock"
          />
        </el-form-item>
        
        <el-form-item label="旧密码" prop="old_password">
          <el-input 
            v-model="formData.old_password" 
            placeholder="输入旧密码" 
            show-password 
            prefix-icon="el-icon-key"
          />
        </el-form-item>
        
        <el-form-item class="submit-item">
          <el-button type="primary" @click="storeProfile()" class="submit-btn">
            <i class="el-icon-check"></i>
            确定修改
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

export default {
  name: 'profile',
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      formData:{},
      rules: {
        new_password: [
          { pattern:/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){8,20}$/,required: true, message: '新密码必须输入8-20位英文字母、数字或者符号,且字母、数字和标点符号至少包含两种', trigger: 'blur' }
        ],
        renew_password: [
          { pattern:/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){8,20}$/,required: true, message: '新密码必须输入8-20位英文字母、数字或者符号,且字母、数字和标点符号至少包含两种', trigger: 'blur' }
        ],
        old_password: [
          { required: true, message: '旧密码必须输入', trigger: 'blur' },
          { min: 5, max: 10, message: '长度在6到10个字符', trigger: 'blur' }
        ],
        admin_tel: [
          { required: true, message: '电话必须输入', trigger: 'blur' },
          {
            validator: function(rule, value, callback) {
              if (
                /^1[34578]\d{9}$/.test(value) === false &&
                /^(\d{3,4}-)?\d{7,8}$/.test(value) === false
              ) {
                callback(new Error('输入正确的座机或者手机'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      downloadLoading: false
    }
  },
  computed: {
  },
  created() {
    this.getUser()
  },
  methods: {
    async getUser() {
      this.storeLoading = true
      let userInfo = JSON.parse(localStorage.getItem('user_info'))
      let res = await this.$api.post('/service/system_user/detail',{id:userInfo.id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
      }else{
        this.$message.error(res.message)
      }
      this.storeLoading = false
    },    
   async storeProfile() {
      let validForm = false
      this.$refs['dataForm'].validate(valid => {
        if (!valid) {
           this.$message.error('数据验证失败，请检查必填项数据！')
           this.$nextTick(() => {
            this.isStartUpload = false
          })
          return
        }
        validForm = true
      })
      if (!validForm) return
      if(this.formData.new_password!=this.formData.renew_password){
        this.$message.error('两输入次新密码不对！')
        return
      }
      const res = await this.$api.post('/service/system_user/update_profile', this.formData)
      if (this.$apiSuccess(res)){
          this.$message.success('保存成功!')
          localStorage.removeItem('token')
          localStorage.removeItem('user_info')
          this.$message.success('退出成功！')
          this.$router.push('/login')
      } else {
          this.$message.error(res.message || '保存失败')
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
  .profile-container
    padding 24px
    min-height calc(100vh - 84px)
    background-color #f5f7fa

  // 页面标题区域
  .page-title-section
    background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    border-radius 12px
    padding 32px
    margin-bottom 24px
    color white
    box-shadow 0 8px 32px rgba(102, 126, 234, 0.15)

  .title-content
    text-align center

  .page-title
    font-size 32px
    font-weight 600
    margin 0 0 8px 0
    display flex
    align-items center
    justify-content center
    gap 12px
    
    i
      font-size 36px

  .page-subtitle
    font-size 16px
    opacity 0.9
    margin 0
    line-height 1.5

  // 表单卡片
  .form-card
    background white
    border-radius 12px
    padding 32px
    max-width 600px
    margin 0 auto
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .form-header
    margin-bottom 24px
    padding-bottom 16px
    border-bottom 2px solid #f0f2f5

  .form-title
    color #1f2937
    font-size 20px
    font-weight 600
    margin 0
    display flex
    align-items center
    gap 8px

  .profile-form
    /deep/ .el-form-item
      margin-bottom 24px
      
    /deep/ .el-form-item__label
      color #374151
      font-weight 500
      font-size 14px

    /deep/ .el-input__inner
      border-radius 8px
      border 1px solid #d1d5db
      padding 12px 15px 12px 40px
      transition all 0.3s ease
      
      &:focus
        border-color #667eea
        box-shadow 0 0 0 3px rgba(102, 126, 234, 0.1)
      
      &:disabled
        background-color #f9fafb
        color #6b7280

    /deep/ .el-input__prefix
      left 12px
      color #9ca3af

  .submit-item
    text-align center
    margin-top 32px

  .submit-btn
    background linear-gradient(45deg, #667eea, #764ba2)
    border none
    border-radius 8px
    padding 14px 32px
    font-weight 500
    font-size 16px
    min-width 180px
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(102, 126, 234, 0.3)

  // 响应式设计
  @media (max-width: 768px)
    .profile-container
      padding 16px
      
    .page-title-section
      padding 24px 20px
      
    .page-title
      font-size 24px
      
    .form-card
      padding 24px 20px
      margin 0 8px
      
    .profile-form
      /deep/ .el-form-item__label
        min-width 100px
</style>
